import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import "./UserInfo.css"
import { BASE_URL } from '../../constants';
import { apiFetch } from "../../utils/apiFetch";

const UserInfo = () => {
  const storedData = localStorage.getItem("userData");
  const userData = storedData ? JSON.parse(storedData) : null;

  const [email, setEmail] = useState(userData?.email || "");
  const [phone, setPhone] = useState(userData?.phone || "");
  const [address, setAddress] = useState(userData?.address || "");

  // Toast üçün state-lər
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success"); // success və ya danger

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!userData) {
      setToastMessage("İstifadəçi məlumatı tapılmadı!");
      setToastVariant("danger");
      setShowToast(true);
      return;
    }

    const updatedData = {
      address: address || "",
      email: email || "",
      name: userData.name || "",
      surname: userData.surname || "",
      phone: phone || "",
      phoneHome: userData.phoneHome || null,
      phoneWhatsApp: userData.phoneWhatsApp || null
    };

    apiFetch(BASE_URL + "/users/me", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedData)
    })
      .then(async res => {
        if (!res.ok) throw new Error("Update failed");
        const text = await res.text();
        return text ? JSON.parse(text) : null;
      })
      .then(data => {
        const newData = data || { ...userData, address, email, phone };
        localStorage.setItem("userData", JSON.stringify(newData));
        setToastMessage("Məlumatlar uğurla yadda saxlanıldı!");
        setToastVariant("success");
        setShowToast(true);
      })
      .catch(err => {
        console.error("Error:", err);
      });
  };

  return (
    <div className="w-100">
      <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-2">
            <Form.Label className="fw-medium">E-poçt</Form.Label>
            <Form.Control
              type="email"
              placeholder="example@gmail.com"
              className="noShadowInput"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="fw-medium">Telefon</Form.Label>
            <Form.Control
              type="tel"
              placeholder="+994..."
              className="noShadowInput"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label className="fw-medium">Ünvan</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ünvan daxil edin"
              className="noShadowInput"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </Form.Group>

          <Button variant="success" className="w-100 py-2 fw-semibold" type='submit'>
            Yadda saxla
          </Button>
      </Form>

      {/* --- Toast Bildiriş Hissəsi --- */}
      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 99999 }}>
        <Toast show={showToast} autohide delay={2000} bg={toastVariant} onClose={() => setShowToast(false)}>
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Sistem Mesajı</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}

export default UserInfo;